import type { AlgoliaProduct } from '~/lib/AlgoliaService/models/AlgoliaProduct';

export function isAlgoliaProduct(result: unknown): result is AlgoliaProduct {
  return typeof result === 'object' && result != null && 'sku' in result;
}
